var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"close-button absolute top-1 right-0 cursor-pointer",on:{"click":_vm.closeModal}},[_c('img',{attrs:{"src":require('../assets/icons/close-icon.svg'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }